import {css, StyleSheet} from "aphrodite";
import React from 'react';
import GridStyles from "../../styles/styles";
import WhatsNewArea from "../WhatsNewArea/WhatsNewArea";
import FeaturesArea from "../FeaturesArea";
import MediaQuery from "../../styles/MediaQuery";
import Switching from "../Switching";

const SwitchA = ({extraStyle, features}) => {
    const styles = StyleSheet.create({
        container: {
            ...GridStyles.define("max-content 70px max-content 101px max-content", "auto"),
            ...MediaQuery.mobile({
                ...GridStyles.define("max-content 50px max-content 58px max-content", "auto")
            })
        },
        whatsNew: GridStyles.setRowCol(1, 1),
        featuresArea: GridStyles.setRowCol(3, 1),
        switching: GridStyles.setRowCol(5, 1),
    });

    return (
        <div className={css(styles.container, extraStyle)}>
            <WhatsNewArea extraStyle={styles.whatsNew}/>
            <FeaturesArea features={features} extraStyle={styles.featuresArea}/>
            <Switching extraStyle={styles.switching}/>
        </div>
    );
};

export default SwitchA;
